import React, { ReactNode } from 'react';

import { Logger } from '@kinopoisk-int/logger';

import { useLogger } from '@/shared/hooks/useLogger';

interface PlayerSkinErrorBoundaryState {
    hasError: boolean;
}

interface PlayerSkinErrorBoundaryInnerProps {
    logger: Logger;
    children: (params: { forceDefaultSkin: boolean }) => ReactNode;
}

class PlayerSkinErrorBoundaryInner extends React.Component<
    PlayerSkinErrorBoundaryInnerProps,
    PlayerSkinErrorBoundaryState
> {
    public static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    // eslint-disable-next-line react/state-in-constructor
    public state = {
        hasError: false,
    };

    public componentDidCatch(error: Error) {
        const { logger } = this.props;

        logger.error({ error }, `PlayerSkinErrorBoundary: ${error.message}`);
    }

    public render() {
        const { hasError } = this.state;
        const { children } = this.props;

        return <>{children({ forceDefaultSkin: hasError })}</>;
    }
}

interface PlayerSkinErrorBoundaryProps {
    children: (params: { forceDefaultSkin: boolean }) => ReactNode;
}

export const PlayerSkinErrorBoundary: React.FC<PlayerSkinErrorBoundaryProps> = ({ children }) => {
    const logger = useLogger();

    return <PlayerSkinErrorBoundaryInner logger={logger}>{children}</PlayerSkinErrorBoundaryInner>;
};
